

class ProductAttribute extends HTMLElement{
  constructor(){
    super();
    this.unit = this.getAttribute("unit");
    this.min = this.getAttribute("min");
    this.max = this.getAttribute("max");
    this.color = this.getAttribute("color");
    this.border = this.getAttribute("show-border");
  }
  connectedCallback() {
    const shadow = this.attachShadow({ mode: "open" });
    const span = document.createElement("span");
    if (this.border=='true'){
      span.className = 'attribute-other-item show-border'
    }else{
      span.className = 'attribute-other-item'
    }
    const randomNumber = this.getRandomInteger(this.min,this.max);
    span.innerHTML = `
      ${randomNumber} ${this.unit}
      <style>
        .attribute-other-item{
            color:${this.color};
        }
        .show-border{
            border-left:1px solid #e1e1e1;
            border-right:1px solid #e1e1e1;
            padding-right:20px;
            padding-left:20px;
        }
        @media(max-width:767px){
          .show-border {
              border-left: 1px solid #e1e1e1;
              border-right: 1px solid #e1e1e1;
              margin-left: 10px;
              margin-right: 10px;
              padding-right: 10px;
              padding-left: 10px;
          }
        }
      </style>
    `;
    shadow.appendChild(span);
  }

  getRandomInteger(min, max) {
    min = parseInt(min, 10);
    max = parseInt(max, 10);
    if (isNaN(min) || isNaN(max)) {
        throw new Error("参数必须是数字或可转换为数字的字符串");
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

customElements.define("product-attributes",ProductAttribute);



// class ProductInquiries extends HTMLElement{
//   constructor(){
//     super();
//   }
// }

// customElements.define("product-inquiries",ProductInquiries);


// class ProductSold extends HTMLElement{
//   constructor(){
//     super();
//   }
// }

// customElements.define("product-sold",ProductSold);
